import addUser from './addUser';

const addProducerBusiness = (model) =>
    addUser({
        ...model,
        role: 'producer_business',
        subuser: false,
    });

export default addProducerBusiness;
